import React from 'react';
import './TierScale.css';

const ALL_TIERS_DATA = [
  { tier: 0, preTitle: 'Immediate action', title: 'Refer to hospital urgently', subtext: '' },
  { tier: 1, preTitle: 'Tier 1', title: 'Urgent investigation of the pancreas and/or immediate referral to specialist', subtext: '' },
  { tier: 2, preTitle: 'Tier 2', title: 'Trial of management or investigation to eliminate other causes over a limited time period', subtext: 'If these do not result in a definitive diagnosis within the recommended time period, order investigative tests of the pancreas.' },
  { tier: 3, preTitle: 'Tier 3', title: 'If patient is aged 50 years or over, consider pancreatic disease if these symptoms or risk factors are persistently experienced and other causes are not identified', subtext: '' },
  { tier: 4, preTitle: 'Monitor symptoms', title: 'Monitor and escalate care if symptoms worsen', subtext: '' },
];

const TierScale = ({ currentTier }) => {
  const activeTierData = ALL_TIERS_DATA.find(t => t.tier === currentTier);
  if (!activeTierData) return null; // Should not happen if currentTier is valid

  // Position calculation: Tiers 0 and 1 are at 0%. Tiers 2, 3, and 4 are spread from ~33% to 100%.
  let indicatorPositionPercent;
  if (currentTier <= 1) {
    indicatorPositionPercent = 0;
  } else {
    // Scale is from Tier 1 to Tier 4 for calculation. (4-1=3 steps)
    indicatorPositionPercent = ((currentTier - 1) / 3) * 100;
  }

  const startLabel = ALL_TIERS_DATA[0].preTitle; // "Immediate action"
  const endLabel = ALL_TIERS_DATA[4].preTitle;   // "Recommendation"

  return (
    <div className="new-tier-scale-container">
      <div className="scale-labels-ends">
        <span className="scale-label-start">{startLabel}</span>
        <span className="scale-label-end">{endLabel}</span>
      </div>
      <div className="scale-bar-wrapper">
        <div className="scale-bar-background"></div>
        <div 
          className="scale-indicator"
          style={{ left: `${indicatorPositionPercent}%` }}
        >
          <div className="indicator-line"></div>
        </div>
      </div>
    </div>
  );
};

export default TierScale;
